import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
import { CTAButton } from './CTAButton';
import { pricingFeatures } from '../data/content';
export function PricingSection() {
  return <section id="precio" className="border-t border-white/5 bg-void-950 py-24 md:py-32" data-id="element-156" data-mp="1eg5qam21ksge">
      <div className="mx-auto max-w-3xl px-6" data-id="element-157" data-mp="1ja9yt9qyh8jl">
        <Reveal className="text-center" data-id="element-158" data-mp="1nb28g43qpfge">
          <div className="flex flex-col items-center" data-id="element-159" data-mp="1naaknfgdwm0o">
            <SectionLabel data-id="element-160" data-mp="1s93wz4jxq6z9">La inversión</SectionLabel>
          </div>
          <h2 className="font-display text-3xl font-light leading-tight text-bone-50 sm:text-4xl md:text-5xl" data-id="element-161" data-mp="1sbgghm5ccpef">
            Una decisión pequeña. Una mirada distinta para siempre.
          </h2>
        </Reveal>

        <Reveal delay={0.08} data-id="element-162" data-mp="2up6oft9qc1n">
          <div className="neon-panel mt-14 rounded-sm border border-gold-500/30 bg-void-900 p-8 sm:p-12" data-id="element-163" data-mp="2vqrvd400ex3">
            <p className="neon-text-soft text-[11px] uppercase tracking-label text-gold-500" data-id="element-164" data-mp="7utoc95wxctg">
              eBook digital
            </p>
            <h3 className="mt-4 font-display text-3xl font-light text-bone-50 sm:text-4xl" data-id="element-165" data-mp="1mirb8dtfe0y1">
              ¿Estás listo para jugar?
            </h3>

            <p className="neon-text mt-8 font-display text-5xl font-light text-gold-400 sm:text-6xl" data-id="element-166" data-mp="1cq3flme6m30w">
              CLP$9.990
            </p>
            <p className="mt-3 text-sm text-bone-500" data-id="element-167" data-mp="17pp948s8b14z">
              Pago único · Acceso inmediato · Para siempre
            </p>

            <ul className="mt-9 space-y-4 border-t border-white/5 pt-9" data-id="element-168" data-mp="20gpf2pa4eeza">
              {pricingFeatures.map(feature => <li key={feature} className="flex items-start gap-3" data-id="element-169" data-mp="1vgbh6028glez">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-500 drop-shadow-[0_0_8px_rgba(34,227,127,0.7)]" aria-hidden="true" data-id="element-170" data-mp="1rg1bkoicrx0n" />
                  <span className="text-sm leading-relaxed text-bone-100 sm:text-base" data-id="element-171" data-mp="g0ug6ggtgo1f">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <CTAButton label="Acceder por $9.990 CLP" className="mt-10 w-full sm:w-auto" data-id="element-172" data-mp="mgkwzzbh1can" />

            <p className="mt-8 text-sm leading-relaxed text-bone-500" data-id="element-173" data-mp="7jlrqi43dvjc">
              Menos que una cena rápida. Una herramienta de reflexión que puede acompañarte por
              años, cada vez que necesites recordar quién eres.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}